import { useState, useEffect } from 'react';
import { getAbsenceStats } from '../../../../services/absenceService';
import { AbsenceStats } from '../../../../types/absenceTypes';

export const useAbsenceStats = () => {
  const [stats, setStats] = useState<AbsenceStats | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoading(true);
        const response = await getAbsenceStats();
        setStats(response.data);
        setError(null);
      } catch (err) {
        setError('Failed to fetch absence statistics');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  return { stats, loading, error };
};

export default useAbsenceStats;
